import React from "react";
import { Progress } from "antd";
import { FloatingForm } from "./Converter";
import CardView from "./CardView";

const ProgressDialog = ({ 
  saveProgress, 
  savedCount, 
  totalCount,
  title = "Saving Payroll",
  processingMessage = "Processing payroll data...",
  successMessage = "Payroll saved successfully!",
  showDetails = true,
  countLabel = "records",
}) => {
  return (
    <FloatingForm width="40%">
      <CardView style={{ padding: "10px" }}>
        <div style={{ padding: "30px 20px" }}>
          <h5
            style={{
              textAlign: "center",
              marginBottom: "20px",
              color: "#333",
            }}
          >
            {saveProgress < 100 ? title : "Complete!"}
          </h5>
          <Progress
            percent={saveProgress}
            status={saveProgress === 100 ? "success" : "active"}
            strokeWidth={10}
            strokeColor={{
              "0%": "#108ee9",
              "100%": "#87d068",
            }}
          />
          {showDetails && (
            <div style={{ marginTop: "20px", textAlign: "center" }}>
              <p
                style={{
                  color: "#666",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                {saveProgress < 100
                  ? processingMessage
                  : successMessage}
              </p>
              <p
                style={{
                  color: "#1890ff",
                  fontSize: "18px",
                  fontWeight: "bold",
                  margin: 0,
                }}
              >
                {savedCount} / {totalCount} {countLabel}
              </p>
            </div>
          )}
        </div>
      </CardView>
    </FloatingForm>
  );
};

export default ProgressDialog;

